import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';

import { SIDEBAR_ROUTES } from './sidebar-routes.config';
import { ISidebarItem } from './sidebar.interface';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  animations: [
    trigger('smoothCollapse', [
      state('close', style({ height: '0', opacity: '0' })),
      state('open', style({ opacity: '1' })),
      transition('* => *', [animate('350ms')]),
    ]),
  ],
})
export class SidebarComponent implements OnInit {
  sidebarItems = SIDEBAR_ROUTES;

  isSidebarVisible = true;
  isInitial = true;

  private storageKey = 'sidebar.isSidebarVisible';

  constructor(private ngxPermissionsService: NgxPermissionsService) {}

  ngOnInit() {
    this.isSidebarVisible = !(
      localStorage.getItem(this.storageKey) === 'false'
    );
    const permissionsArray = new Set(
      Object.values(this.ngxPermissionsService.getPermissions()).map((x) => {
        return x.name;
      }),
    );

    for (const sidebarItem of this.sidebarItems) {
      let i = 0;

      if (sidebarItem.subMenu !== undefined) {
        for (const y of sidebarItem.subMenu) {
          const found = y.avilableFor?.some((r) => {
            return permissionsArray.has(r);
          });
          if (!found) {
            i++;
          }
        }
      }

      if (
        sidebarItem.subMenu !== undefined &&
        sidebarItem.subMenu.length === i
      ) {
        sidebarItem.subMenu = [];
      }
    }
  }

  toggleSidebar() {
    this.isSidebarVisible = !this.isSidebarVisible;
    localStorage.setItem(this.storageKey, this.isSidebarVisible.toString());
  }

  toggleSubMenu(item: ISidebarItem): void {
    item.isCollapsed = !item.isCollapsed;
  }

  onRouterLinkActive(item: ISidebarItem) {
    if (this.isInitial && !item.isCollapsed) {
      this.toggleSubMenu(item);
      this.isInitial = false;
    }
  }
}
